import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { globalize } from "../translate";

interface Props {
  dateTime: LocalDateTime;
}

const ClockHour = (props: Props) => (
  <span>{globalize().formatLocalDateTime(props.dateTime, { time: "short" })}</span>
);
export default ClockHour;
